// src/services/automatizaciones.ts
/**
 * Service para operaciones de Automatizaciones/Triggers.
 */
import { api } from './api';

export interface Automatizacion {
  id: string;
  nombre: string;
  descripcion?: string;
  trigger: TriggerTipo;
  condiciones: CondicionGroup;
  acciones: Accion[];
  config_temporal?: { horas: number };
  orden: number;
  activo: boolean;
  creado_por_nombre?: string;
  ejecuciones_count: number;
  ultima_ejecucion?: string;
  created_at: string;
  updated_at: string;
}

export interface AutomatizacionListItem {
  id: string;
  nombre: string;
  trigger: TriggerTipo;
  activo: boolean;
  orden: number;
  ejecuciones_count: number;
  ultima_ejecucion?: string;
  created_at: string;
}

export interface AutomatizacionEjecucion {
  id: string;
  automatizacion_id: string;
  trigger_tipo: TriggerTipo;
  recurso_tipo: string;
  recurso_id: string;
  estado: 'EXITOSA' | 'FALLIDA' | 'PARCIAL';
  acciones_ejecutadas: Record<string, unknown>[];
  error?: string;
  ejecutada_at: string;
  duracion_ms?: number;
}

export type TriggerTipo = 'TICKET_CREADO' | 'TICKET_SIN_RESPUESTA' | 'TICKET_REABIERTO' | 'CONVERSACION_NUEVA';

export interface Condicion {
  campo: string;
  operador: string;
  valor: unknown;
}

export interface CondicionGroup {
  logica: 'AND' | 'OR';
  condiciones: Condicion[];
}

export interface Accion {
  tipo: string;
  config: Record<string, unknown>;
}

export interface AutomatizacionCreate {
  nombre: string;
  descripcion?: string;
  trigger: TriggerTipo;
  condiciones: CondicionGroup;
  acciones: Accion[];
  config_temporal?: { horas: number };
  orden?: number;
}

export interface AutomatizacionUpdate {
  nombre?: string;
  descripcion?: string;
  trigger?: TriggerTipo;
  condiciones?: CondicionGroup;
  acciones?: Accion[];
  config_temporal?: { horas: number };
  orden?: number;
  activo?: boolean;
}

export const automatizacionesService = {
  list: (soloActivos?: boolean) => {
    const params = soloActivos ? '?solo_activos=true' : '';
    return api.get<AutomatizacionListItem[]>(`/automatizaciones${params}`);
  },

  get: (id: string) => api.get<Automatizacion>(`/automatizaciones/${id}`),

  create: (data: AutomatizacionCreate) =>
    api.post<Automatizacion>('/automatizaciones', data),

  update: (id: string, data: AutomatizacionUpdate) =>
    api.patch<Automatizacion>(`/automatizaciones/${id}`, data),

  delete: (id: string) => api.delete<void>(`/automatizaciones/${id}`),

  getEjecuciones: (id: string, skip = 0, limit = 50) =>
    api.get<AutomatizacionEjecucion[]>(
      `/automatizaciones/${id}/ejecuciones?skip=${skip}&limit=${limit}`
    ),

  test: (id: string, recursoTipo: string, recursoId: string) =>
    api.post<{ condiciones_match: boolean; acciones: unknown[] }>(
      `/automatizaciones/${id}/test`,
      { recurso_tipo: recursoTipo, recurso_id: recursoId }
    ),
};
